import React, { useState, useRef } from 'react';
import { DropzoneArea as DZA } from 'material-ui-dropzone';
import { MAXSIZE, MAXWIDTH } from '../drop-area';
import { fileIsImage, getImageDims } from '../../utils';
import SnackAlerts from 'global/components/snack-alerts';
import { get, set, size } from 'global/lib/lodash';

export const DropzoneArea = React.forwardRef((props, ref) => {
  const [alerts, setAlerts] = useState();
  const dropRef = useRef(ref);

  const onChange = async (files) => {
    try {
      const errors = [];
      const acceptedFiles = [];
      const rejected = [];
      await Promise.all(
        files.map(async (file, index) => {
          const isImage = fileIsImage(file);
          const dims = isImage ? await getImageDims(file) : null;
          if (isImage && (dims.width >= MAXWIDTH || dims.height >= MAXWIDTH)) {
            errors.push({ message: `${get(file, 'name')}'s dimensions are greater then ${MAXWIDTH}px` });
            rejected.push({ file, index });
          } else {
            acceptedFiles.push(file);
          }
        })
      );

      const del = get(dropRef, 'current.deleteFile', () => 0);
      rejected.map((rej) => {
        del(rej.file, rej.index);
      });
      props.onChange && props.onChange(acceptedFiles);
      if (size(errors)) {
        const hasAlert = props.onAlert;
        const message = errors.map((e) => e.message).join(', ');
        if (hasAlert) {
          props.onAlert && props.onAlert(message, 'overwrite');
        } else {
          setAlerts({
            message,
            severity: 'error',
          });
        }
      }
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  set(ref, 'current', dropRef.current);

  return (
    <>
      <DZA ref={dropRef} maxFileSize={MAXSIZE} {...props} onChange={onChange} />
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </>
  );
});
